module.exports = __webpack_public_path__ + "static/media/colegio-nss.9fd13c47.jpg";